export const colors = {
  primary: '#FF3B30', // vivid red, game accent
  accent: '#FFD60A', // bright yellow
  background: '#0F1724', // dark navy
  surface: '#0B1220', // darker panel
  textPrimary: '#FFFFFF',
  textMuted: '#A0AEC0',
  success: '#34C759',
  danger: '#FF453A',
};

export const spacing = {
  xs: 6,
  sm: 10,
  md: 16,
  lg: 24,
  xl: 36,
};

export const typography = {
  h1: { fontSize: 28, fontWeight: '700' as const },
  h2: { fontSize: 20, fontWeight: '700' as const },
  body: { fontSize: 16, fontWeight: '400' as const },
};

export default { colors, spacing, typography };
